export const getSrcSetString = ({ url, quality = 60, widths = [60, 120] }) => {
    if (!url) {
        return url;
    }
    return widths
        .map(
            width => `${url}?disable=upscale&auto=webp&quality=${quality}&width=${width} ${width}w`
        )
        .join(', ');
};

export const getSrcSetStringForHeights = ({ url, quality = 60, heights = [60, 120] }) => {
    if (!url) {
        return url;
    }
    return heights
        .map(
            height =>
                `${url}?disable=upscale&auto=webp&quality=${quality}&height=${height} ${height}w`
        )
        .join(', ');
};

// Should only be used for images uploaded via cms, since we do not know the widths of those images
export const getSrcString = ({ url }) => {
    return `${url}?disable=upscale&auto=webp&quality=60`;
};
